export default "__VITE_ASSET__Cv8Peh3z__"